var createHistory = require('history').createBrowserHistory;
export default createHistory();


// WEBPACK FOOTER //
// ./src/history.js